import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import TickIcon from 'app/images/icons/tick.svg';
import ProcessingIcon from 'app/images/icons/refresh.svg';


export default class PaymentBadge extends React.PureComponent {
  static propTypes = {
    paymentText: PropTypes.string,
    className: PropTypes.string,
    tick: PropTypes.bool,
  };

  static defaultProps = {
    paymentText: undefined,
    className: undefined,
    tick: true,
  };

  badgeColor = (paymentText) => {
    let color = 'grey';
    let checked = false;
    let processing = false;
    if (paymentText === 'Overdue') {
      color = 'red';
    }
    if (paymentText === 'Cancelled') {
      color = 'black';
    }
    if (paymentText === 'Walkover') {
      color = 'black';
    }
    if (paymentText === 'Forfeit') {
      color = 'black';
    }
    if (paymentText === 'No-show') {
      color = 'black';
    }
    if (paymentText === 'Up-to-date') {
      color = 'green';
    }
    if (paymentText === 'Collecting') {
      color = 'purple';
      processing = true;
    }
    if (paymentText === 'Collected') {
      color = 'green';
      checked = true;
    }
    if (paymentText === 'Owing') {
      color = 'medium-grey';
    }
    if (paymentText === 'Setting Up') {
      color = 'medium-grey';
    }
    if (paymentText === 'Overdue') {
      color = 'red';
    }
    if (paymentText === 'Transferred') {
      color = 'dark-purple';
    }
    if (
      paymentText === 'Paid'
      || paymentText === 'Paid Teammo'
      || paymentText === 'Teammo'
    ) {
      color = 'purple';
      checked = true;
    }
    if (paymentText === 'Paid Cash' || paymentText === 'Cash') {
      color = 'orange';
      checked = true;
    }
    if (paymentText === 'Paid Eftpos' || paymentText === 'Eftpos') {
      color = 'blue';
      checked = true;
    }
    if (paymentText === 'Paid Pre-paid' || paymentText === 'Pre-paid') {
      color = 'yellow';
      checked = true;
    }
    return [color, checked, processing];
  };

  render(): React.ReactNode {
    const [badgeColor, checked, processing] = this.badgeColor(this.props.paymentText);

    return (
      <Badge
        className={`${this.props.className} payment-badge float-right`}
        color={badgeColor}
      >
        {this.props.paymentText}
        {this.props.tick && checked && <Isvg className="tick" src={TickIcon} />}
        {this.props.tick && processing && <Isvg className="processing" src={ProcessingIcon} />}
      </Badge>
    );
  }
}
